// Colour by how much the vertex shader moved the surface
vec3 effect(vec2 uv)
{
    return mix(sampleCam(uv), heat(vElevation * 0.5 + 0.5), uAmount);
}
